<template>
	<div class="o-dashboard">

		<c-table
			ref="table"
			:columns="columns"
			:endpoint="'/api/roles'"
			:search="false">
		</c-table>

		<c-new-roles-rights
			v-show="modal"
			@close="modal=false"
			@added="load"
			:size="'medium'">
		</c-new-roles-rights>

	</div>
</template>

<script>
import View from '@mixins/View';
import Form from '@mixins/Form';
import CTable from '@components/table/Table';
import CNewRolesRights from '@app/modals/NewRolesRights';

export default {
	mixins: [ View, Form ],
	components: { CTable, CNewRolesRights },

	data() {
		return {
			modal: false,
		}
	},
	methods: {
		openModal() {
			this.modal = true;
		},
		load(){
			this.$refs.table.load();
		}
	},
	created() {
		this.$store.dispatch('listener/on', {
			event: 'new-roles-rights',
			listener: this.openModal
		});
	},
	beforeUnmount() {
		this.$store.dispatch('listener/off', {
			event: 'new-roles-rights',
			listener: this.openModal
		});
	},
	computed: {
		columns() {
			let columns = [
				{ name: 'name', label: 'Rol'},
				{ name: 'description', label: 'Omschrijving'},
				{ name: 'users.length', label: 'Gebruikers'},
				{ name: "id", label: '', component: 'CColumnButton', props: { route: 'rolesRightsDetail' }}
			];

			return columns;
		}
	}
}
</script>
